export const locale = {
    lang: 'fr',
    data: {
        TRANSFORM_LIST: 'Transformer cartes en listes',
        SELECTION: 'Sélection',
        ACTIVITY: 'Activité',
    }
};
